import React from "react"
import moment from "moment"

import styles from "./ChristmasBanner.css"

function getThanksgivingDay() {
  const november = 10
  const lastDayOfNovember = moment({ day: 30, month: november }).day()
  const thanksgivingDay = (lastDayOfNovember >= 4 ? 34 : 27) - lastDayOfNovember
  return moment({ day: thanksgivingDay, month: november })
}

function ChristmasBanner() {
  const dayAfterCyberMonday = getThanksgivingDay().add(5, "days")
  const december = 11
  const dayAfterChristmas = moment({ day: 26, month: december })
  const now = moment()

  return false && now.isBetween(dayAfterCyberMonday, dayAfterChristmas) && (
    <div className={styles.root}>
      <span className={styles.text}>
        All items purchased after the 10th of December {now.year()} are not guaranteed to arrive before Christmas.
      </span>
    </div>
  )
}

export default ChristmasBanner



// WEBPACK FOOTER //
// ./src/shared/components/ChristmasBanner/ChristmasBanner.js